import { connect } from 'react-redux';
import { projectRouteTreeTooltipDataChanged } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import { getRoutesTreeTooltip } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';
import RouteThumbnailsFullTreeContainer from './RouteThumbnailsFullTreeContainerBase';

const mapStateToProps = (state) => ({
  treeTooltip: getRoutesTreeTooltip(state),
});

const mapActionToProps = {
  updateTreeThumbnailDetails: projectRouteTreeTooltipDataChanged,
};

export default connect(mapStateToProps, mapActionToProps)(RouteThumbnailsFullTreeContainer);
